
<p-confirmDialog />

<div class="card">
  <div class="card-content">
  <!-- Stats cards row (shared stats-cards styles) -->
  <div class="stats-cards-row">
    <div class="stats-card stats-card--total">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ totalEmployeesCount }}</span>
        <span class="stats-card-label">Total Employees</span>
        <!-- Not month-filtered: this is the roster the month is planned against, and the
             four cards beside it split exactly this number. -->
        <span class="stats-card-sublabel">Active &amp; allocatable</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-users"></i></div>
    </div>
    <div class="stats-card stats-card--fully-allocated stats-card--clickable"
         [class.stats-card--active]="selectedStatusFilter === 'fully'"
         (click)="filterByStatus('fully')"
         title="Click to filter fully allocated employees">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ fullyAllocatedCount }}</span>
        <span class="stats-card-label">Fully Allocated</span>
        <span class="stats-card-sublabel">{{ fullyAllocatedPercent }}% of workforce</span>
        <div class="stats-card-progress">
          <div class="stats-card-progress-fill" [style.width.%]="fullyAllocatedPercent"></div>
        </div>
      </div>
      <div class="stats-card-icon"><i class="pi pi-check-square"></i></div>
    </div>
    <!-- Someone at 50% every week is neither full, over, nor unallocated. Without this card
         they were counted in the total but shown in none of the breakdown, so the four
         numbers did not add up to it. -->
    <div class="stats-card stats-card--partially-allocated stats-card--clickable"
         [class.stats-card--active]="selectedStatusFilter === 'partial'"
         (click)="filterByStatus('partial')"
         title="Click to filter partially allocated employees">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ partiallyAllocatedCount }}</span>
        <span class="stats-card-label">Partially Allocated</span>
        <span class="stats-card-sublabel">Has spare capacity</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-chart-pie"></i></div>
    </div>
    <div class="stats-card stats-card--over-allocated stats-card--clickable"
         [class.stats-card--active]="selectedStatusFilter === 'over'"
         (click)="filterByStatus('over')"
         title="Click to filter over-allocated employees">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ overAllocatedCount }}</span>
        <span class="stats-card-label">Over Allocated</span>
        <span class="stats-card-sublabel">Exceeds 100%</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-exclamation-triangle"></i></div>
    </div>
    <div class="stats-card stats-card--not-allocated stats-card--clickable"
         (click)="showUnallocatedEmployeesDialog()"
         title="Click to view unallocated employees">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ notAllocatedCount }}</span>
        <span class="stats-card-label">Not Allocated</span>
        <span class="stats-card-sublabel">Needs assignment</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-circle"></i></div>
    </div>
  </div>

  <!-- Action bar: left = Copy / Close / Export / Unallocated; right = Add Allocation -->
  <div class="controls-section sticky-controls mb-4">
    <div class="controls-left">
      <p-button
        *ngIf="canCopyToNextMonth()"
        label="Copy to Next Month"
        icon="pi pi-copy"
        (onClick)="copyToNextMonth()"
        severity="secondary"
        styleClass="btn-copy-action" />

      <p-button
        *ngIf="canCloseMonth()"
        label="Close Month"
        icon="pi pi-lock"
        (onClick)="closeMonth()"
        severity="danger" />

      <p-button
        *ngIf="canReopenMonth()"
        label="Reopen Month"
        icon="pi pi-unlock"
        (onClick)="reopenMonth()"
        severity="warn" />

      <p-button
        *ngIf="canExportToExcel()"
        label="Export Excel"
        icon="pi pi-file-excel"
        (onClick)="exportToExcel()"
        severity="success"
        styleClass="btn-export-excel" />

      <p-button
        [label]="'Unallocated (' + notAllocatedCount + ')'"
        icon="pi pi-eye"
        (onClick)="showUnallocatedEmployeesDialog()"
        severity="secondary"
        styleClass="btn-unallocated" />
    </div>
    <div class="page-header-actions-right">
      <div class="page-header-search">
        <div class="search-box">
          <i class="pi pi-search"></i>
          <input
            pInputText
            id="search"
            [(ngModel)]="searchText"
            (input)="onSearch()"
            placeholder="Search employee, project, cost center..."
            class="search-input" />
          <p-button
            *ngIf="searchText"
            icon="pi pi-times"
            (onClick)="clearSearch()"
            [text]="true"
            severity="secondary"
            size="small"
            styleClass="search-clear-btn" />
        </div>
      </div>
      <p-button
        *ngIf="canAddAllocation()"
        label="Add Allocation"
        icon="pi pi-plus"
        (onClick)="showAddDialog()"
        severity="primary" />
    </div>
  </div>

  <!-- Filters + Search Section -->
  <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
    <div class="filter-bar-filters">
      <div class="filter-field">
      <label for="roleFilter" class="filter-label">Role</label>
      <p-multiSelect id="roleFilter" [(ngModel)]="selectedRoles" (ngModelChange)="applyFilters()"
        [options]="roleOptions" optionLabel="label" optionValue="value" placeholder="All Roles"
        display="chip" [showToggleAll]="true" [filter]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
      <label for="pmFilter" class="filter-label">PM</label>
      <p-multiSelect id="pmFilter" [(ngModel)]="selectedPMs" (ngModelChange)="applyFilters()"
        [options]="pmOptions" optionLabel="label" optionValue="value" placeholder="All PMs"
        display="chip" [showToggleAll]="true" [filter]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
      <label for="projectFilter" class="filter-label">Project</label>
      <p-multiSelect id="projectFilter" [(ngModel)]="selectedProjects" (ngModelChange)="applyFilters()"
        [options]="projectOptions" optionLabel="label" optionValue="value" placeholder="All projects"
        display="chip" [showToggleAll]="true" [filter]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
      <label for="projectTypeFilter" class="filter-label">Project Type</label>
      <p-select id="projectTypeFilter" [(ngModel)]="projectTypeFilter" (ngModelChange)="applyFilters()"
        [options]="projectTypeOptions" optionLabel="label" optionValue="value"
        placeholder="All projects" panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
      <label for="invoiceTypeFilter" class="filter-label">Invoice Type</label>
      <p-multiSelect id="invoiceTypeFilter" [(ngModel)]="selectedInvoiceTypes" (ngModelChange)="applyFilters()"
        [options]="invoiceTypeOptions" optionLabel="label" optionValue="value" placeholder="Invoice Type"
        display="chip" [showToggleAll]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
      <label for="costCenterFilter" class="filter-label">Cost Center</label>
      <p-multiSelect id="costCenterFilter" [(ngModel)]="selectedCostCenters" (ngModelChange)="applyFilters()"
        [options]="costCenterOptions" optionLabel="label" optionValue="value" placeholder="All Cost Centers"
        display="chip" [showToggleAll]="true" [filter]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
      <label for="serviceGroupFilter" class="filter-label">Service Group</label>
      <p-multiSelect id="serviceGroupFilter" [(ngModel)]="selectedServiceGroups" (ngModelChange)="applyFilters()"
        [options]="serviceGroupOptions" optionLabel="label" optionValue="value" placeholder="All service groups"
        display="chip" [showToggleAll]="true" [filter]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field filter-field--checkbox">
        <label class="availability-toggle" for="availabilityFilter">
          <p-checkbox
            inputId="availabilityFilter"
            [(ngModel)]="showOnlyAvailable"
            (ngModelChange)="onAvailabilityFilterChange()"
            [binary]="true" />
          <span>Has Availability</span>
        </label>
      </div>
    </div>

    <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
      <button
        type="button"
        class="btn-clear-filters"
        (click)="clearFilters()"
        title="Clear all filters">
        <i class="pi pi-filter-slash"></i>
      </button>
    </div>
  </div>

  <p-table
    [scrollable]="true" scrollHeight="flex"
    [value]="allocationDisplayRows"
    [loading]="loading"
    [tableStyle]="{ 'width': '100%' }"
    [resizableColumns]="true"
    columnResizeMode="fit"
    styleClass="allocation-table table-flat table-no-xscroll resize-handles-visible">

    <ng-template pTemplate="header">
      <tr>
        <!-- Only the identity columns are resizable. The W1–W5 cells are uniform
             narrow numeric inputs, and columnResizeMode="fit" keeps the table
             within the viewport (this grid deliberately never scrolls sideways). -->
        <th pResizableColumn class="allocation-col-employee" pSortableColumn="sortEmployeeKey">
          Employee
          <p-sortIcon field="sortEmployeeKey" />
        </th>
        <th pResizableColumn class="allocation-col-project" pSortableColumn="sortProjectName">
          Project / PM
          <p-sortIcon field="sortProjectName" />
        </th>
        <th pResizableColumn class="col-invoice-type" pSortableColumn="sortInvoiceType">
          Invoice
          <p-sortIcon field="sortInvoiceType" />
        </th>
        <th class="allocation-col-week">W1</th>
        <th class="allocation-col-week">W2</th>
        <th class="allocation-col-week">W3</th>
        <th class="allocation-col-week">W4</th>
        <th class="allocation-col-week">W5</th>
        <th *ngIf="canShowActionsColumn" class="col-actions allocation-col-actions">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <!-- Project allocation row: same columns every row; employee info in col 1 only on first row of each employee -->
      @if (row.rowType === 'project') {
        <tr [ngClass]="{
          'available-project-row': row.allocation.projectName?.toLowerCase() === 'available',
          'row-allocation-not-100': isRowAllocationNot100(row.allocation)
        }">
          <td class="allocation-cell-employee">
            @if (row.isFirstInGroup && row.employeeDisplay) {
              <div class="table-employee-wrap table-cell-hover" [pTooltip]="row.employeeDisplay.employeeName + (row.employeeDisplay.roleLabel ? '\n' + row.employeeDisplay.roleLabel : '')" tooltipPosition="top">
                <span class="table-employee-avatar" [title]="row.employeeDisplay.employeeName">{{ row.employeeDisplay.initials }}</span>
                <div class="table-employee-info">
                  <span class="table-employee-name">{{ row.employeeDisplay.employeeName }}</span>
                  <span class="table-employee-role">{{ row.employeeDisplay.roleLabel }}</span>
                </div>
              </div>
              <div class="allocation-employee-divider"></div>
            }
          </td>
          <td class="allocation-cell-project table-cell-hover" [pTooltip]="getProjectCellTooltip(row.allocation)" tooltipPosition="top">
            <span class="allocation-project-name">
              {{ row.allocation.projectName }}
              <!-- Both are presales, but the tooltip for a deal would be wrong on an
                   activity, so the chip names which one it is. -->
              <span class="presales-chip"
                    *ngIf="row.allocation.isProjectPresales && !row.allocation.isProjectPresalesActivity"
                    pTooltip="In-pursuit presales deal — not yet won" tooltipPosition="top">Presales</span>
              <span class="presales-chip" *ngIf="row.allocation.isProjectPresalesActivity"
                    pTooltip="Presales tracker activity" tooltipPosition="top">Activity</span>
            </span>
            <span class="allocation-project-meta">PM: {{ row.allocation.managerName || '—' }}</span>
          </td>
          <td class="allocation-cell-invoice">
            <span class="invoice-type-badge invoice-type-badge--{{ getInvoiceTypeSeverity(row.allocation.invoiceType) }}">
              <i class="pi pi-circle-fill invoice-type-badge-dot" aria-hidden="true"></i>
              {{ getInvoiceTypeLabel(row.allocation.invoiceType) }}
            </span>
          </td>
          <td class="allocation-cell-week">
            <div class="allocation-week-cell">
              <div class="allocation-week-track"><div class="allocation-week-bar" [ngClass]="'allocation-week-bar--' + getWeekPercentSeverity(row.allocation.week1Percentage)" [style.width.%]="row.allocation.week1Percentage ?? 0"></div></div>
              <span class="allocation-week-value" [ngClass]="'allocation-week-value--' + getWeekPercentSeverity(row.allocation.week1Percentage)">{{ row.allocation.week1Percentage != null ? (row.allocation.week1Percentage + '%') : '—' }}</span>
            </div>
          </td>
          <td class="allocation-cell-week">
            <div class="allocation-week-cell">
              <div class="allocation-week-track"><div class="allocation-week-bar" [ngClass]="'allocation-week-bar--' + getWeekPercentSeverity(row.allocation.week2Percentage)" [style.width.%]="row.allocation.week2Percentage ?? 0"></div></div>
              <span class="allocation-week-value" [ngClass]="'allocation-week-value--' + getWeekPercentSeverity(row.allocation.week2Percentage)">{{ row.allocation.week2Percentage != null ? (row.allocation.week2Percentage + '%') : '—' }}</span>
            </div>
          </td>
          <td class="allocation-cell-week">
            <div class="allocation-week-cell">
              <div class="allocation-week-track"><div class="allocation-week-bar" [ngClass]="'allocation-week-bar--' + getWeekPercentSeverity(row.allocation.week3Percentage)" [style.width.%]="row.allocation.week3Percentage ?? 0"></div></div>
              <span class="allocation-week-value" [ngClass]="'allocation-week-value--' + getWeekPercentSeverity(row.allocation.week3Percentage)">{{ row.allocation.week3Percentage != null ? (row.allocation.week3Percentage + '%') : '—' }}</span>
            </div>
          </td>
          <td class="allocation-cell-week">
            <div class="allocation-week-cell">
              <div class="allocation-week-track"><div class="allocation-week-bar" [ngClass]="'allocation-week-bar--' + getWeekPercentSeverity(row.allocation.week4Percentage)" [style.width.%]="row.allocation.week4Percentage ?? 0"></div></div>
              <span class="allocation-week-value" [ngClass]="'allocation-week-value--' + getWeekPercentSeverity(row.allocation.week4Percentage)">{{ row.allocation.week4Percentage != null ? (row.allocation.week4Percentage + '%') : '—' }}</span>
            </div>
          </td>
          <td class="allocation-cell-week">
            <div class="allocation-week-cell">
              <div class="allocation-week-track"><div class="allocation-week-bar" [ngClass]="'allocation-week-bar--' + getWeekPercentSeverity(row.allocation.week5Percentage)" [style.width.%]="row.allocation.week5Percentage ?? 0"></div></div>
              <span class="allocation-week-value" [ngClass]="'allocation-week-value--' + getWeekPercentSeverity(row.allocation.week5Percentage)">{{ row.allocation.week5Percentage != null ? (row.allocation.week5Percentage + '%') : '—' }}</span>
            </div>
          </td>
          <td *ngIf="canShowActionsColumn" class="table-cell-actions" (click)="$event.stopPropagation()">
            <div class="table-actions-stack">
              <p-button
                *ngIf="canAddAllocation()"
                icon="pi pi-plus-circle"
                (onClick)="quickAddForRow(row.allocation, $event)"
                [text]="true"
                severity="success"
                size="small"
                pTooltip="Add allocation for this employee"
                tooltipPosition="top"
                ariaLabel="Add allocation for this employee" />
              <p-button
                *ngIf="canEditAllocation(row.allocation)"
                icon="pi pi-pencil"
                (onClick)="onEditAllocationClick(row.allocation, $event)"
                [text]="true"
                severity="info"
                size="small"
                ariaLabel="Edit allocation" />
              <p-button
                *ngIf="canDeleteAllocation(row.allocation)"
                icon="pi pi-trash"
                (onClick)="onDeleteAllocationClick(row.allocation, $event)"
                [text]="true"
                severity="danger"
                size="small"
                ariaLabel="Delete allocation" />
            </div>
          </td>
        </tr>
      }

      <!-- Synthetic Available row: auto-computed remaining capacity (shown in red) -->
      @if (row.rowType === 'available') {
        <tr class="available-computed-row" pTooltip="Remaining capacity across all projects this month" tooltipPosition="left">
          <td class="allocation-cell-employee"></td>
          <td class="allocation-cell-project">
            <span class="allocation-project-name available-computed-label">Available</span>
            <span class="allocation-project-meta available-computed-meta">Remaining capacity</span>
          </td>
          <td class="allocation-cell-invoice"></td>
          @for (w of row.availableWeeks; track $index) {
            <td class="allocation-cell-week">
              <div class="allocation-week-cell">
                <div class="allocation-week-track"><div class="allocation-week-bar allocation-week-bar--available" [style.width.%]="w"></div></div>
                <span class="allocation-week-value allocation-week-value--available">{{ w }}%</span>
              </div>
            </td>
          }
          <td *ngIf="canShowActionsColumn" class="table-cell-actions"></td>
        </tr>
      }

      <!-- Total row -->
      @if (row.rowType === 'total') {
        <tr class="allocation-row-total">
          <td class="allocation-cell-total-label" colspan="3">{{ row.employeeName }} — Total</td>
          @for (w of row.totals; track $index) {
            <!-- Same track + bar + value structure as the week cells above, so the total row reads as
                 part of the same scale instead of bare text. Bar is capped at 100% width; the value
                 still shows the true figure (e.g. 125%). -->
            <td class="allocation-cell-week allocation-cell-total-value">
              <div class="allocation-week-cell">
                <div class="allocation-week-track">
                  <div class="allocation-week-bar allocation-week-bar--total"
                    [ngClass]="'allocation-week-bar--' + getWeekPercentSeverity(row.totals[$index])"
                    [style.width.%]="row.totals[$index] > 100 ? 100 : row.totals[$index]"></div>
                </div>
                <span class="allocation-week-value allocation-total-value"
                  [ngClass]="'allocation-week-value--' + getWeekPercentSeverity(row.totals[$index])">
                  {{ row.totals[$index] }}%
                </span>
              </div>
            </td>
          }
          <td *ngIf="canShowActionsColumn" class="table-cell-actions"></td>
        </tr>
      }
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr class="table-empty-row">
        <td colspan="9" class="table-empty-cell">
          <div class="empty-state">
            <div class="empty-icon"><i class="pi pi-inbox"></i></div>
            <p class="empty-message">No allocations found</p>
            <p class="empty-description">{{ searchText ? 'No results match your search criteria. Try adjusting filters or search.' : 'Add an allocation to get started.' }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  </div>
</div>

<p-dialog
  [visible]="displayDialog"
  (visibleChange)="displayDialog = $event; !$event && hideDialog()"
  [header]="isEditMode ? 'Edit Allocation' : 'Add Allocation'"
  [modal]="true"
  styleClass="dialog-xl allocation-form-dialog"
  [dismissableMask]="true"
  [closable]="true">

  <div class="p-fluid form-dialog-container form-dialog-form form-dialog-spacious allocation-form">
    <!-- Details section: two-column responsive layout -->
    <!-- Section: allocation details (shared .alloc-section card, same as Future Allocation) -->
    <div class="alloc-section alloc-section--details">
      <div class="alloc-section-head"><i class="pi pi-user"></i> Allocation Details</div>
    <div class="form-row two-columns allocation-details-row">
      <div class="field" [class.field-invalid]="fieldTouched['employeeId'] && !selectedAllocation.employeeId">
        <label for="employee">Employee *</label>
        <p-select
          id="employee"
          [(ngModel)]="selectedAllocation.employeeId"
          (ngModelChange)="onEmployeeChange($event)"
          (onBlur)="fieldTouched['employeeId'] = true"
          [options]="activeEmployees"
          optionLabel="name"
          optionValue="id"
          placeholder="Select an employee"
          [filter]="true"
          [showClear]="true"
          appendTo="body" />
        <small class="field-error" *ngIf="fieldTouched['employeeId'] && !selectedAllocation.employeeId">Please select an employee</small>
      </div>
      <div class="field">
        <label for="role">Role *</label>
        <p-select
          id="role"
          [(ngModel)]="selectedAllocation.roleId"
          (ngModelChange)="onRoleChange($event)"
          [options]="allocationRoleOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select a role"
          appendTo="body" [filter]="true" filterPlaceholder="Search…" />
        <small
          *ngIf="selectedAllocation.employeeId && allocationRoleOptions.length === 0"
          class="p-text-secondary">
          No roles assigned to this employee. Assign roles on the Employee page.
        </small>
      </div>
    </div>

    <!-- Available Percentage Card -->
    <div class="field grid" *ngIf="showAvailablePercentageCard && availablePercentageInfo">
      <div class="col-12">
        <div class="available-percentage-card">
          <div class="card-header">
            <div class="card-header-left">
              <i class="pi pi-info-circle"></i>
              <span>Available Capacity</span>
            </div>
            <p-button
              label="Fill with Available"
              icon="pi pi-check"
              (onClick)="fillWithAvailablePercentages()"
              severity="success"
              size="small" />
          </div>
          <div class="card-content">
            <div class="capacity-grid">
              <div class="capacity-item">
                <span class="week-label">Week 1</span>
                <span class="percentage-value">{{ getAvailableCapacityForDisplay(1) }}%</span>
              </div>
              <div class="capacity-item">
                <span class="week-label">Week 2</span>
                <span class="percentage-value">{{ getAvailableCapacityForDisplay(2) }}%</span>
              </div>
              <div class="capacity-item">
                <span class="week-label">Week 3</span>
                <span class="percentage-value">{{ getAvailableCapacityForDisplay(3) }}%</span>
              </div>
              <div class="capacity-item">
                <span class="week-label">Week 4</span>
                <span class="percentage-value">{{ getAvailableCapacityForDisplay(4) }}%</span>
              </div>
              <div class="capacity-item">
                <span class="week-label">Week 5</span>
                <span class="percentage-value">{{ getAvailableCapacityForDisplay(5) }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-row two-columns allocation-details-row">
      <div class="field" [class.field-invalid]="fieldTouched['projectId'] && !selectedAllocation.projectId">
        <!-- "& Activities": the list also carries tracker activities marked allocatable,
             not just projects and pursuits. -->
        <!-- Stays a direct child of .field: the global `.field > label` rule carries the
             uppercase label styling, and a wrapper div would break that selector. -->
        <label for="project">Project / Presales Activity *</label>
        <p-select
          id="project"
          [(ngModel)]="selectedAllocation.projectId"
          (ngModelChange)="onProjectChange($event)"
          (onBlur)="fieldTouched['projectId'] = true"
          [options]="projectDisplayOptions"
          optionLabel="label"
          optionValue="value"
          [placeholder]="projectPlaceholder"
          [filter]="true"
          [filterPlaceholder]="projectFilterPlaceholder"
          [emptyMessage]="projectEmptyMessage"
          [showClear]="true"
          appendTo="body" />
        <small class="field-error" *ngIf="fieldTouched['projectId'] && !selectedAllocation.projectId">Please select a project</small>
        <!-- Below the control, not above it: anything between the label and the dropdown
             pushes this column's input off the baseline shared with Invoice Type. -->
        <div class="project-type-toggles">
          <span class="project-type-toggles__label">Show</span>
          <label class="project-type-toggle" *ngFor="let opt of formProjectTypeOptions">
            <p-checkbox
              [inputId]="'projectType-' + opt.key"
              [(ngModel)]="formProjectTypes[opt.key]"
              [ngModelOptions]="{ standalone: true }"
              [binary]="true" />
            <span>{{ opt.label }}</span>
          </label>
        </div>
        <!-- Without this an unticked box looks like missing data rather than an active filter. -->
        <small class="field-hint" *ngIf="noProjectTypeSelected">All types are unticked — tick at least one to choose a project.</small>
      </div>
      <div class="field">
        <label for="invoiceType">Invoice Type</label>
        <p-select
          id="invoiceType"
          [(ngModel)]="selectedAllocation.invoiceType"
          [options]="invoiceTypeOptions"
          optionLabel="label"
          optionValue="value"
          [placeholder]="selectedAllocation.projectId ? 'Select invoice type' : 'Select a project first (defaults from project)'"
          [disabled]="!selectedAllocation.projectId"
          appendTo="body" />
      </div>
    </div>

    <div class="form-row two-columns allocation-details-row">
      <div class="field">
        <label for="costCenter">Cost Center</label>
        <p-select
          id="costCenter"
          [(ngModel)]="selectedAllocation.costCenterId"
          (ngModelChange)="onCostCenterChange($event)"
          [options]="costCenterDisplayOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select a cost center"
          [filter]="true"
          filterPlaceholder="Search cost center..."
          [showClear]="false"
          [disabled]="!selectedAllocation.projectId"
          appendTo="body" />
      </div>
      <div class="field">
        <label for="serviceGroup">Service Group</label>
        <p-select
          id="serviceGroup"
          [(ngModel)]="selectedAllocation.serviceGroupId"
          [options]="serviceGroupDisplayOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select a project first"
          [disabled]="true"
          appendTo="body" [filter]="true" filterPlaceholder="Search…" />
      </div>
    </div>

    </div><!-- /alloc-section--details -->

    <div class="alloc-section alloc-section--periods">
    <div class="weekly-percentages-section">
      <!-- Header mirrors the Future Allocation form: title left, "Set all → Apply" quick-fill right. -->
      <div class="percentages-header">
        <label class="weekly-percentages-title">Weekly Percentages</label>
        <div class="percentages-quickfill">
          <span class="percentages-quickfill-label">Set all</span>
          <p-inputNumber [(ngModel)]="applyAllValue" [min]="0" [max]="100" [showButtons]="false"
            suffix="%" inputStyleClass="percentages-quickfill-input" />
          <p-button label="Apply" icon="pi pi-arrow-down" (onClick)="applyAllWeeks()"
            severity="info" size="small" pTooltip="Fill every week with this value" tooltipPosition="top" />
        </div>
      </div>
      <div class="week-percentages-columns">
        <div class="week-percentage-col" [class.week-col-over]="getRemainingPercentage(1) < 0">
          <label for="week1" class="week-col-label">Week 1 %</label>
          <div class="week-col-meta">
            <span class="remaining-badge" [ngClass]="{'over-allocated': getRemainingPercentage(1) < 0}">{{ getRemainingPercentage(1) < 0 ? 'Over: ' : 'Remaining: ' }}{{ getRemainingPercentage(1) }}%</span>
            <a class="use-available-link" [class.disabled]="!availablePercentageInfo || getRemainingPercentage(1) <= 0"
              (click)="(availablePercentageInfo && getRemainingPercentage(1) > 0) && fillWeekWithAvailable(1)">
              <i class="pi pi-arrow-right"></i> Use Available
            </a>
          </div>
          <p-select id="week1" [(ngModel)]="selectedAllocation.week1Percentage" (ngModelChange)="onWeekPercentageChange(1, $event)" [options]="getWeekPercentageOptions(1)" optionLabel="label" optionValue="value" placeholder="%" [showClear]="false" [editable]="true" [disabled]="isWeekInputDisabled(1)" appendTo="body" class="w-full" />
        </div>
        <div class="week-percentage-col" [class.week-col-over]="getRemainingPercentage(2) < 0">
          <label for="week2" class="week-col-label">Week 2 %</label>
          <div class="week-col-meta">
            <span class="remaining-badge" [ngClass]="{'over-allocated': getRemainingPercentage(2) < 0}">{{ getRemainingPercentage(2) < 0 ? 'Over: ' : 'Remaining: ' }}{{ getRemainingPercentage(2) }}%</span>
            <a class="use-available-link" [class.disabled]="!availablePercentageInfo || getRemainingPercentage(2) <= 0"
              (click)="(availablePercentageInfo && getRemainingPercentage(2) > 0) && fillWeekWithAvailable(2)">
              <i class="pi pi-arrow-right"></i> Use Available
            </a>
          </div>
          <p-select id="week2" [(ngModel)]="selectedAllocation.week2Percentage" (ngModelChange)="onWeekPercentageChange(2, $event)" [options]="getWeekPercentageOptions(2)" optionLabel="label" optionValue="value" placeholder="%" [showClear]="false" [editable]="true" [disabled]="isWeekInputDisabled(2)" appendTo="body" class="w-full" />
        </div>
        <div class="week-percentage-col" [class.week-col-over]="getRemainingPercentage(3) < 0">
          <label for="week3" class="week-col-label">Week 3 %</label>
          <div class="week-col-meta">
            <span class="remaining-badge" [ngClass]="{'over-allocated': getRemainingPercentage(3) < 0}">{{ getRemainingPercentage(3) < 0 ? 'Over: ' : 'Remaining: ' }}{{ getRemainingPercentage(3) }}%</span>
            <a class="use-available-link" [class.disabled]="!availablePercentageInfo || getRemainingPercentage(3) <= 0"
              (click)="(availablePercentageInfo && getRemainingPercentage(3) > 0) && fillWeekWithAvailable(3)">
              <i class="pi pi-arrow-right"></i> Use Available
            </a>
          </div>
          <p-select id="week3" [(ngModel)]="selectedAllocation.week3Percentage" (ngModelChange)="onWeekPercentageChange(3, $event)" [options]="getWeekPercentageOptions(3)" optionLabel="label" optionValue="value" placeholder="%" [showClear]="false" [editable]="true" [disabled]="isWeekInputDisabled(3)" appendTo="body" class="w-full" />
        </div>
        <div class="week-percentage-col" [class.week-col-over]="getRemainingPercentage(4) < 0">
          <label for="week4" class="week-col-label">Week 4 %</label>
          <div class="week-col-meta">
            <span class="remaining-badge" [ngClass]="{'over-allocated': getRemainingPercentage(4) < 0}">{{ getRemainingPercentage(4) < 0 ? 'Over: ' : 'Remaining: ' }}{{ getRemainingPercentage(4) }}%</span>
            <a class="use-available-link" [class.disabled]="!availablePercentageInfo || getRemainingPercentage(4) <= 0"
              (click)="(availablePercentageInfo && getRemainingPercentage(4) > 0) && fillWeekWithAvailable(4)">
              <i class="pi pi-arrow-right"></i> Use Available
            </a>
          </div>
          <p-select id="week4" [(ngModel)]="selectedAllocation.week4Percentage" (ngModelChange)="onWeekPercentageChange(4, $event)" [options]="getWeekPercentageOptions(4)" optionLabel="label" optionValue="value" placeholder="%" [showClear]="false" [editable]="true" [disabled]="isWeekInputDisabled(4)" appendTo="body" class="w-full" />
        </div>
        <div class="week-percentage-col" [class.week-col-over]="getRemainingPercentage(5) < 0">
          <label for="week5" class="week-col-label">Week 5 %</label>
          <div class="week-col-meta">
            <span class="remaining-badge" [ngClass]="{'over-allocated': getRemainingPercentage(5) < 0}">{{ getRemainingPercentage(5) < 0 ? 'Over: ' : 'Remaining: ' }}{{ getRemainingPercentage(5) }}%</span>
            <a class="use-available-link" [class.disabled]="!availablePercentageInfo || getRemainingPercentage(5) <= 0"
              (click)="(availablePercentageInfo && getRemainingPercentage(5) > 0) && fillWeekWithAvailable(5)">
              <i class="pi pi-arrow-right"></i> Use Available
            </a>
          </div>
          <p-select id="week5" [(ngModel)]="selectedAllocation.week5Percentage" (ngModelChange)="onWeekPercentageChange(5, $event)" [options]="getWeekPercentageOptions(5)" optionLabel="label" optionValue="value" placeholder="%" [showClear]="false" [editable]="true" [disabled]="isWeekInputDisabled(5)" appendTo="body" class="w-full" />
        </div>
      </div>
    </div>

    </div><!-- /alloc-section--periods -->

    <div class="alloc-section alloc-section--comments">
      <div class="alloc-section-head"><i class="pi pi-comment"></i> Comments</div>
    <div class="field grid">
      <!-- No visible label: the card head above already reads "Comments". The textarea keeps an
           aria-label so screen readers still announce the field. -->
      <div class="col-12">
        <textarea
          id="comments"
          [(ngModel)]="selectedAllocation.comments"
          rows="3"
          class="p-inputtext"
          aria-label="Comments"
          placeholder="Enter comments"></textarea>
      </div>
    </div>
    </div><!-- /alloc-section--comments -->
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button
        label="Reset"
        icon="pi pi-refresh"
        (onClick)="resetAllocationForm()"
        severity="secondary"
        [text]="true"
        styleClass="btn-form-reset" />
      <p-button
        label="Cancel"
        icon="pi pi-times"
        (onClick)="hideDialog()"
        severity="secondary"
        [text]="true" />
      <p-button
        label="Save"
        icon="pi pi-check"
        (onClick)="saveAllocation()"
        severity="primary" />
    </div>
  </ng-template>
</p-dialog>

<!-- Un-Allocated Employees Dialog (shared dialog + allocation-page table styles; header fixed) -->
<p-dialog
  [visible]="displayUnallocatedDialog"
  (visibleChange)="displayUnallocatedDialog = $event"
  [modal]="true"
  styleClass="dialog-workforce unallocated-employees-dialog"
  [dismissableMask]="true"
  [closable]="true">

  <ng-template pTemplate="header">
    <div class="dialog-header-with-meta">
      <span class="dialog-header-title">Workforce</span>
      <span class="dialog-header-badge">{{ workforceDialogRows.length }}</span>
      <span class="dialog-header-period">{{ getMonthName(selectedMonth) }} {{ selectedYear }}</span>
    </div>
  </ng-template>

  <div *ngIf="loadingUnallocated" class="loading-container">
    <p class="text-muted">Loading employees...</p>
  </div>

  <div *ngIf="!loadingUnallocated" class="unallocated-dialog-inner">

    <!-- Three populations the headline cards do not separate: who still needs planning, who
         is deliberately out of scope, and who has left. Tabs keep them distinct without
         three buttons on the toolbar. -->
    <div class="workforce-tabs" role="tablist">
      <button type="button" class="workforce-tab" role="tab"
              [class.workforce-tab--active]="workforceTab === 'unallocated'"
              [attr.aria-selected]="workforceTab === 'unallocated'"
              (click)="selectWorkforceTab('unallocated')">
        Not Allocated
        <span class="workforce-tab-count">{{ unallocatedEmployees.length }}</span>
      </button>
      <button type="button" class="workforce-tab" role="tab"
              [class.workforce-tab--active]="workforceTab === 'excluded'"
              [attr.aria-selected]="workforceTab === 'excluded'"
              (click)="selectWorkforceTab('excluded')">
        Excluded
        <span class="workforce-tab-count">{{ excludedEmployees.length }}</span>
      </button>
      <button type="button" class="workforce-tab" role="tab"
              [class.workforce-tab--active]="workforceTab === 'inactive'"
              [attr.aria-selected]="workforceTab === 'inactive'"
              (click)="selectWorkforceTab('inactive')">
        Inactive
        <span class="workforce-tab-count">{{ inactiveEmployees.length }}</span>
      </button>
    </div>

    <p class="workforce-tab-hint">{{ workforceTabHint }}</p>

    <div class="unallocated-table-scroll-holder">
    <!-- The table owns the scroll area (see _unallocated-dialog.scss), so no paginator:
         tabs, hint and footer stay put while only the rows move, and the row count is
         already on the tab badge and in the footer. -->
    <!-- One table instance per tab (ngFor over a single-item array keyed by the tab name).
         Each tab has a different column set, so this makes Angular destroy and rebuild the
         table on a tab change, letting the persist directive — which reads its key once on
         init — pick up that tab's own saved widths. -->
    <ng-container *ngFor="let tabKey of [workforceTab]; trackBy: trackByTabKey">
    <!-- No [tableStyle] min-width: the stylesheet sizes the table to 100% of the wrapper so
         it fits without sideways scrolling. An inline min-width here would be applied on top
         of the dragged pixel width and reintroduce the overflow. -->
    <p-table
      [value]="workforceDialogRows"
      [paginator]="false"
      [resizableColumns]="true"
      columnResizeMode="expand"
      [persistColumnWidths]="'workforce-' + tabKey"
      styleClass="compact-striped-table unallocated-dialog-table resize-handles-visible">

      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn class="unallocated-col-name">Employee Name</th>
          <th pResizableColumn class="unallocated-col-email">Email</th>
          <th pResizableColumn class="unallocated-col-role">Role</th>
          <th pResizableColumn class="unallocated-col-designation">Designation</th>
          <th pResizableColumn class="unallocated-col-category">Category</th>
          <th pResizableColumn class="unallocated-col-service">Service Group</th>
          <th pResizableColumn class="unallocated-col-left" *ngIf="workforceTab === 'inactive'">Last Working Day</th>
          <!-- Someone who has left, or is excluded, can still hold a plan for the month.
               Flagging them explains why the Effort Variance report counts more employees.
               Narrow last column, so no resize grip: it would crowd the header for a
               Yes/— value that never needs more room. -->
          <th class="unallocated-col-alloc" *ngIf="workforceTab !== 'unallocated'">Allocated</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-employee>
        <tr>
          <td class="unallocated-cell-name">
            <!-- Only the unallocated can actually be given an allocation, so the shortcut is
                 a plain name on the other tabs rather than a link that would fail. -->
            <button *ngIf="workforceTab === 'unallocated'" type="button" class="unallocated-name-link"
              (click)="openAddAllocationForEmployee(employee)"
              [pTooltip]="'Add allocation for ' + employee.name"
              tooltipPosition="top">{{ employee.name }}</button>
            <span *ngIf="workforceTab !== 'unallocated'" class="unallocated-cell-text"
              [pTooltip]="employee.name" tooltipPosition="top">{{ employee.name }}</span>
          </td>
          <td class="unallocated-cell-email"><span class="unallocated-cell-text" [pTooltip]="(employee.email || '-')" tooltipPosition="top">{{ employee.email || '-' }}</span></td>
          <td class="unallocated-cell-role"><span class="unallocated-cell-text" [pTooltip]="getRoleName(employee.roleId)" tooltipPosition="top">{{ getRoleName(employee.roleId) }}</span></td>
          <td class="unallocated-cell-designation"><span class="unallocated-cell-text" [pTooltip]="(employee.designationName || '-')" tooltipPosition="top">{{ employee.designationName || '-' }}</span></td>
          <td class="unallocated-cell-category"><span class="unallocated-cell-text" [pTooltip]="(employee.categoryName || '-')" tooltipPosition="top">{{ employee.categoryName || '-' }}</span></td>
          <td class="unallocated-cell-service"><span class="unallocated-cell-text" [pTooltip]="(employee.serviceGroupName || getServiceGroupName(employee.serviceGroupId) || '-')" tooltipPosition="top">{{ employee.serviceGroupName || getServiceGroupName(employee.serviceGroupId) || '-' }}</span></td>
          <td class="unallocated-cell-left" *ngIf="workforceTab === 'inactive'">
            <span class="unallocated-cell-text">{{ formatInactiveDate(employee.inactiveDate) }}</span>
          </td>
          <td class="unallocated-cell-alloc" *ngIf="workforceTab !== 'unallocated'">
            <span *ngIf="hasAllocationInPeriod(employee.id)" class="workforce-alloc-flag"
                  pTooltip="Has an allocation for this month. They cannot be assigned new work, but their planned hours still appear in reports that cover everyone."
                  tooltipPosition="top">Yes</span>
            <span *ngIf="!hasAllocationInPeriod(employee.id)" class="unallocated-cell-muted">&mdash;</span>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row table-empty-row--compact">
          <td [attr.colspan]="workforceTab === 'inactive' ? 8 : (workforceTab === 'excluded' ? 7 : 6)"
              class="table-empty-cell">
            <div class="empty-state empty-state--compact">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">Nothing to show</p>
              <p class="empty-description">{{ workforceTabEmptyMessage }}</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </ng-container>
    </div>
  </div>
  
  <ng-template pTemplate="footer">
    <!-- Every tab lists people who are NOT on the plan, so the allocated figure — the one
         that answers "how is the month looking" — appears nowhere else in this dialog.
         Stated here rather than as another tab, which would duplicate the grid behind. -->
    <div class="workforce-footer">
      <span class="workforce-footer-summary">
        <strong>{{ totalEmployeesCount }}</strong> active
        <span class="workforce-footer-sep">&middot;</span>
        <strong>{{ allocatedEmployeeCount }}</strong> allocated
        <span class="workforce-footer-sep">&middot;</span>
        <strong>{{ notAllocatedCount }}</strong> not allocated
        <!-- Reports that do not filter by active status (Effort Variance) count these too,
             so naming the number here is what reconciles the two screens. -->
        <span *ngIf="offRosterAllocatedCount > 0" class="workforce-footer-note"
              [pTooltip]="offRosterTooltip" tooltipPosition="top">
          &plus;{{ offRosterAllocatedCount }} inactive/excluded with a plan
          <i class="pi pi-info-circle" aria-hidden="true"></i>
        </span>
      </span>
      <span class="workforce-footer-actions">
        <p-button
          label="Close"
          icon="pi pi-times"
          (onClick)="hideUnallocatedDialog()"
          severity="secondary" />
        <p-button
          label="Export Excel"
          icon="pi pi-file-excel"
          (onClick)="exportUnallocatedToExcel()"
          severity="success" />
      </span>
    </div>
  </ng-template>
</p-dialog>


